/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  captureguideData: null,
  lastUpdated: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetCaptureGuideAction.REQUEST_CAPTURE_GUIDE:
      return {
        ...state
      };
    case actions.GetCaptureGuideAction.CAPTURE_GUIDE_RECEIVED:
      return {
        ...state,
        captureguideData: action.data,
        lastUpdated: Date.now()
      };

    default:
      return state;
  }
};

export default reducer;
